import { FC, ReactNode } from 'react';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { SxProps } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

interface Props {
  action?: ReactNode;
  condensed?: boolean;
  image?: ReactNode;
  message?: ReactNode;
  sx?: SxProps;
  title: ReactNode;
}

export const EmptyBox: FC<Props> = ({ action, condensed = true, image, message, sx, title }) => {
  return (
    <Box
      sx={{ bgcolor: 'background.paper', borderRadius: 2.5, padding: condensed ? 5 : 9, ...sx }}
      textAlign="center"
      width="100%"
    >
      <Stack spacing={3}>
        {image && (
          <Box display="flex" justifyContent="center" width="100%">
            {image}
          </Box>
        )}
        <Stack alignItems="center" spacing={2}>
          {typeof title === 'string' ? (
            <Typography color="text.primary" variant="h6">
              {title}
            </Typography>
          ) : (
            title
          )}
          {!!message &&
            (typeof message === 'string' ? (
              <Typography
                maxWidth="550px"
                sx={{ color: 'text.secondary' }}
                variant="body1"
                whiteSpace="pre-line"
              >
                {message}
              </Typography>
            ) : (
              message
            ))}
        </Stack>
        {action && <div>{action}</div>}
      </Stack>
    </Box>
  );
};
